// University of Houston's undergraduate majors (#2748). Read on 2026-10-01
// from UH Undergraduate Admissions' Colleges and Degrees page, which lists
// every area of study under the college that offers it and links the
// 2026-2027 Undergraduate Catalog. The catalog itself (publications.uh.edu)
// answered every request with a bot challenge, so the admissions list is
// used; it names no degree types, so each degree is null. Its seven
// pre-professional tracks are left out (UH says they are not majors).
// Campus notes in parentheses (Katy, Sugar Land) are UH's own. Group notes
// quote the same page. The KB's majors list was the starting point; the
// school's page wins.
const majors = {
    "slug": "university-of-houston",
    "read": "2026-10-01",
    "intro": "Every undergraduate major UH Admissions lists on its Colleges and Degrees page, grouped by the college that offers it. Pre-professional tracks, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Gerald D. Hines College of Architecture and Design",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "note": "New Environmental Design students select Architecture as their major when applying.",
            "majors": [
                {
                    "name": "Architecture",
                    "degree": null
                },
                {
                    "name": "Environmental Design",
                    "degree": null
                },
                {
                    "name": "Industrial Design",
                    "degree": null
                },
                {
                    "name": "Interior Architecture",
                    "degree": null
                }
            ]
        },
        {
            "name": "Kathrine G. McGovern College of the Arts",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Graphic Design",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Music Therapy",
                    "degree": null
                },
                {
                    "name": "Painting",
                    "degree": null
                },
                {
                    "name": "Performance",
                    "degree": null
                },
                {
                    "name": "Photography/Video",
                    "degree": null
                },
                {
                    "name": "Sculpture",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                }
            ]
        },
        {
            "name": "C. T. Bauer College of Business",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "note": "All new students are admitted as Pre-Business and declare a business major after the required university and business core classes.",
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Entrepreneurship",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Management Information Systems",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Supply Chain Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Health",
                    "degree": null
                },
                {
                    "name": "Human Development and Family Sciences",
                    "degree": null
                },
                {
                    "name": "Teaching and Learning",
                    "degree": null
                }
            ]
        },
        {
            "name": "Cullen College of Engineering",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering and Analytics (Katy)",
                    "degree": null
                },
                {
                    "name": "Construction Engineering (Katy)",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Industrial Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Multidisciplinary Engineering",
                    "degree": null
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": null
                },
                {
                    "name": "Systems Engineering (Katy)",
                    "degree": null
                }
            ]
        },
        {
            "name": "Cullen College of Engineering: Technology Division",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Biotechnology (Sugar Land)",
                    "degree": null
                },
                {
                    "name": "Computer Engineering Technology (Sugar Land)",
                    "degree": null
                },
                {
                    "name": "Computer Information Systems (Sugar Land)",
                    "degree": null
                },
                {
                    "name": "Construction Management",
                    "degree": null
                },
                {
                    "name": "Digital Media",
                    "degree": null
                },
                {
                    "name": "Electrical Power Engineering Technology (Sugar Land)",
                    "degree": null
                },
                {
                    "name": "Human Resource Development",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering Technology (Sugar Land)",
                    "degree": null
                },
                {
                    "name": "Retailing and Consumer Science (Sugar Land)",
                    "degree": null
                },
                {
                    "name": "Supply Chain and Logistics Technology",
                    "degree": null
                },
                {
                    "name": "Technology Leadership and Innovation Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "Conrad N. Hilton College of Global Hospitality Leadership",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Global Hospitality Leadership",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Social Sciences",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Chinese Studies",
                    "degree": null
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": null
                },
                {
                    "name": "Communication Studies",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Exercise and Fitness Studies",
                    "degree": null
                },
                {
                    "name": "Exercise Science",
                    "degree": null
                },
                {
                    "name": "Global Studies and Languages",
                    "degree": null
                },
                {
                    "name": "Health Communication",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Human Nutrition and Foods",
                    "degree": null
                },
                {
                    "name": "Journalism",
                    "degree": null
                },
                {
                    "name": "Kinesiology",
                    "degree": null
                },
                {
                    "name": "Liberal Studies",
                    "degree": null
                },
                {
                    "name": "Media Production",
                    "degree": null
                },
                {
                    "name": "Mexican American and Latino/a Applied Studies",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy, Politics & Economics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Sport Administration",
                    "degree": null
                },
                {
                    "name": "Strategic Communication",
                    "degree": null
                },
                {
                    "name": "Women's, Gender & Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Natural Sciences and Mathematics",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Atmospheric Science",
                    "degree": null
                },
                {
                    "name": "Biochemical and Biophysical Sciences",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Earth Science",
                    "degree": null
                },
                {
                    "name": "Environmental Sciences",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "Geophysics",
                    "degree": null
                },
                {
                    "name": "Honors Biomedical Sciences",
                    "degree": null
                },
                {
                    "name": "Mathematical Biology",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                }
            ]
        },
        {
            "name": "Andy and Barbara Gessner College of Nursing",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "note": "Nursing majors apply to UH as Pre-Nursing and apply for the BSN program once prerequisite coursework is complete.",
            "majors": [
                {
                    "name": "Nursing",
                    "degree": null
                }
            ]
        },
        {
            "name": "Hobby School of Public Affairs",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": null
                }
            ]
        },
        {
            "name": "Undergraduate Student Success",
            "source": {
                "label": "UH Undergraduate Admissions, Colleges and Degrees",
                "url": "https://www.uh.edu/undergraduate-admissions/academics/index.php"
            },
            "majors": [
                {
                    "name": "Integrated Studies",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
